<template>
  <div>
    <div class="banner">
      <!-- 第一屏 -->
      <div style="width: 100%; height: 1080px"></div>
      <div style="width: 100%; height: 100%">
        <div style="position: fixed; top: 0; left: 0; z-index: 99; width: 100%"
             ref="heads">
          <headers></headers>
        </div>

        <img style="width: 100%; position: absolute; top: 0; height: 1080px"
             src="../assets/images/bgc@2x.png"
             alt="中财专技" />
        <div class="bgc"></div>
      </div>

      <!-- 第二屏 -->
      <div class="jyBox">
        <div class="zcBox">
          <div class="vitts">
            <img class="citsImg"
                 src="../assets/images/zcimg/cits.png"
                 alt="" />
          </div>
          <div class="zcText">
            <div>
              <img src="../assets/images/zcimg/zcsj.png"
                   alt="" />
            </div>
            <div class="tbox">
              <div style="text-indent: 2em">
                中财首佳（北京）教育科技有限公司是一家位于首都北京的科技型教育企业，专注于人才发展与职业能力提升。公司充分发挥“互联网+教育”的平台优势，深度整合信息化技术与优质教学内容，联合国内高校与行业资深专家，构建线上线下深度融合的创新培训模式。我们紧密围绕国家人才发展战略，致力于为各领域专业人才的持续成长打造良性、高效的学习生态。
              </div>
              <div style="text-indent: 2em">
                公司核心团队经验丰富，技术实力扎实，拥有雄厚的师资储备与成熟的行业资源。我们始终以市场需求和客户价值为导向，确保课程体系兼具专业深度与实践前沿性，紧跟政策与行业动态，持续更新知识与技能模块。
              </div>
              <div style="text-indent: 2em">
                公司运用先进的互联网技术和海量优质的网络课程资源打造“中财专技在线”平台，依托平台面向全国的专业技术人员、事业单位工作人员、企业管理人员及高等院校，开展专业技术人员继续教育、职业培训和在职学历教育服务等业务。公司为合作伙伴提供先进的网络平台、优质的课程资源、专业的运营组织以及高效的市场推广服务。
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三屏 -->
      <div class="zyjs">
        <div class="xwzx">
          <div class="xwTitle">新闻资讯</div>
          <div class="zxList">
            <div class="zxBox"
                 v-for="item in pictureNews"
                 :key="item.id" @click="zxDetil(item)">
              <div class="z1">
                <img style="width: 100%;height: 100%;"
                     :src="item.picUrl"
                     alt="" />
              </div>
              <div class="z2">
                <div class="z3">{{ item.picTitle }}</div>
                <div class="z4">
                  <div v-html="item.picDesc">

                  </div>
                </div>
                <div class="z5">{{ item.picTypeName == null ? '' : item.picTypeName}}</div>
              </div>
            </div>
          </div>

          <div class="moreZx" @click="more">
            <div>查看更多资讯</div>
            <div style="margin-left: 4px"><img src="../assets/images/zcimg/moreIcon.png"
                   alt="" /></div>
          </div>
        </div>
      </div>

      <!-- 第四屏 -->
      <div class="gm">
        <div class="gm1">
          <div class="gmTitle">公司运营规模</div>
          <div class="g2">{{ yyTtitle }}</div>

          <div class="giconList">
            <div class="gi1">
              <div>
                <div style="display: flex; justify-content: center"><img src="../assets/images/zcimg/g1.png"
                       alt="" /></div>
                <div class="gi2">先进性</div>
                <div class="gi3">行业前沿技术方案</div>
              </div>
            </div>
            <div class="gi1">
              <div>
                <div style="display: flex; justify-content: center"><img src="../assets/images/zcimg/g2.png"
                       alt="" /></div>
                <div class="gi2">安全性</div>
                <div class="gi3">严格安全防护设计</div>
              </div>
            </div>
            <div class="gi1">
              <div>
                <div style="display: flex; justify-content: center"><img src="../assets/images/zcimg/g3.png"
                       alt="" /></div>
                <div class="gi2">开放性</div>
                <div class="gi3">各种资源开放共享</div>
              </div>
            </div>
            <div class="gi1">
              <div>
                <div style="display: flex; justify-content: center"><img src="../assets/images/zcimg/g4.png"
                       alt="" /></div>
                <div class="gi2">扩展性</div>
                <div class="gi3">多平台协同服务</div>
              </div>
            </div>
            <div class="gi1">
              <div>
                <div style="display: flex; justify-content: center"><img src="../assets/images/zcimg/g5.png"
                       alt="" /></div>
                <div class="gi2">高效性</div>
                <div class="gi3">简洁UI高效易上手</div>
              </div>
            </div>
            <div class="gi1">
              <div>
                <div style="display: flex; justify-content: center"><img src="../assets/images/zcimg/g6.png"
                       alt="" /></div>
                <div class="gi2">兼容性</div>
                <div class="gi3">适用于各种终端系统</div>
              </div>
            </div>
          </div>

          <div class="gmxc">
            <div class="gmxc1">
              <div class="t1">合作单位</div>
              <div class="t2">服务于各类合作单位院校</div>
              <div class="t3"
                   style="margin-top: 18px">·{{ hzdw }} 已合作单位</div>
              <div class="t3">·{{ hpl }} 客户好评率</div>
              <img class="gc1"
                   src="../assets/images/zcimg/gc1.png"
                   alt="" />
              <img class="g1Img"
                   src="../assets/images/zcimg/gg1.png"
                   alt="" />
            </div>
            <div class="gmxc1"
                 style="background: linear-gradient(0deg, #fff2e6 0%, #fff9f9 100%)">
              <div class="t1">培训学员</div>
              <div class="t2">助力专业技术人员知识更新</div>
              <div class="t3"
                   style="margin-top: 18px">·{{ xxrs }} 在线学习人数</div>
              <img class="gc1"
                   src="../assets/images/zcimg/gc2.png"
                   alt="" />
              <img class="g1Img"
                   src="../assets/images/zcimg/gg2.png"
                   alt="" />
            </div>
            <div class="gmxc2">
              <div class="t4">
                <img class="g1Img"
                     src="../assets/images/zcimg/gg3.png"
                     alt="" />
                <div class="t1">涵盖专业</div>
                <div class="t2">全面覆盖专业技术人员学习要求</div>
                <div class="t3">·{{ zyfx }} 专业方向</div>
              </div>
              <div class="t4">
                <img class="g1Img"
                     src="../assets/images/zcimg/gg5.png"
                     alt="" />
                <div class="t1">课程学时</div>
                <div class="t2">课程超多学时选择</div>
                <div class="t3">·{{ kcxs }} 课程总学时</div>
              </div>
            </div>
            <div class="gmxc2">
              <div class="t4">
                <img class="g1Img"
                     src="../assets/images/zcimg/gg4.png"
                     alt="" />
                <div class="t1">海量课程</div>
                <div class="t2">优质专业课程资源内容</div>
                <div class="t3">·{{ ptkc }} 平台课程</div>
              </div>
              <div class="t4">
                <img class="g1Img"
                     src="../assets/images/zcimg/gg6.png"
                     alt="" />
                <div class="t1">累计学习</div>
                <div class="t2">累计播放次数</div>
                <div class="t3">·{{ ljxx }} 次播放</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kcfw">
        <img class="kcbgc"
             src="../assets/images/zcimg/kcfw.png"
             alt="" />

        <div class="gmTitle">课程服务范围</div>
        <div class="g2">我们对各行业的用户调查和市场分析，确保能针对不同行业开发出最适合客户的课程</div>

        <!-- 循环渲染每一行 -->
        <div class="scroll-container">
          <!-- 循环渲染每一行 -->
          <div v-for="(row, rowIndex) in rowList"
               :key="rowIndex"
               :class="['scroll-row', rowIndex % 2 === 0 ? 'right' : 'left']"
               @mouseenter="pauseScroll(rowIndex)"
               @mouseleave="resumeScroll(rowIndex)"
               :style="{ animationPlayState: pauseStates[rowIndex] ? 'paused' : 'running' }">
            <!-- 复制一份数据实现无缝循环 -->
            <div class="scroll-content">
              <div v-for="(item, idx) in row"
                   :key="idx"
                   class="card">
                <span v-if="item.codeName !== '待上线1' && item.codeName !== '待上线2' && item.codeName !== '待上线3'" class="card-text">{{ item.codeName }}</span>
              </div>
            </div>
            <div class="scroll-content clone">
              <div v-for="(item, idx) in row"
                   :key="idx"
                   class="card">
                <span class="card-text">{{ item.codeName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="csw">
        <div class="gmTitle">合作案例</div>
        <div class="g2">围绕平台建设、技术服务提供全流程解决方案，高效落地项目需求，实现稳定运行与良好成效，获客户高度认可</div>

        <div class="hzImg">
          <img src="../assets/images/hzal.png"
               alt="" />
        </div>
      </div>

      <div class="kcfw1"
           style="height: 650px">
        <img class="kcbgc"
             src="../assets/images/zcimg/zczy.png"
             alt="" />

        <div class="gmTitle"
             style="color: #fff">中财专业服务</div>
        <div class="g2"
             style="color: #fff">
          涵盖需求分析、方案设计、实施部署、运维保障与培训支持，以规范流程、高效响应和稳定交付，持续提升客户使用体验与业务价值
        </div>

        <div class="zyList">
          <div class="z1"
               v-for="item in bottomInfoList"
               :key="item.id">
            <div class="z2">{{ item.picTitle }}</div>
            <div class="z3">
              <div v-html="item.picDesc"></div>
            </div>
            <div class="z4">
              <img style="width: 100%;height: 100%;"
                   :src="item.picUrl"
                   alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <flotRight />

    <pcBottom></pcBottom>

  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import headers from './component/head.vue';
import pcBottom from './component/bottom.vue';
import Baywindow from './component/Baywindow.vue';
import flotRight from '@/views/component/flotRight.vue';
import sztd from './component/sztd.vue';
import jxfw from './component/jxfw.vue';
import xyxs from './component/xyxs.vue';
import hzdw from './component/hzdw.vue';
import kpzq from './component/kpzq.vue';
import { getInfo } from '../api/index';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    headers,
    sztd,
    jxfw,
    xyxs,
    hzdw,
    kpzq,
    pcBottom,
    Baywindow,
    flotRight
  },

  data() {
    // 这里存放数据
    return {
    
      // 每行显示的卡片数量（根据你的图是10个/行）
      perRow: 10,
      // 记录每行的暂停状态（true=暂停，false=运行）
      pauseStates: {},
      codeList: [], //首页滚动的课程分类
      pictureNews: [], //资讯
      yunYingList: [], //运营
      bottomInfoList: [], //底部资讯
      yyTtitle: '',
      hzdw: '',
      hpl: '',
      xxrs: '',
      zyfx: '',
      ptkc: '',
      kcxs: '',
      ljxx: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {
    rowList() {
      const rows = [];
      for (let i = 0; i < this.codeList.length; i += this.perRow) {
        rows.push(this.codeList.slice(i, i + this.perRow));
      }
      return rows;
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    zxDetil(item) {
      console.log(item.id);
      this.$router.push({
        path:'/tzgg',
        query:{
          id:item.id,
          picType:item.picType,
        }
      })
    },
    more() {
      this.$router.push('/tzgg')
    },
    // 暂停某一行滚动
    pauseScroll(rowIndex) {
      this.$set(this.pauseStates, rowIndex, true);
    },
    // 恢复某一行滚动
    resumeScroll(rowIndex) {
      this.$set(this.pauseStates, rowIndex, false);
    },
    getInfo() {
      getInfo().then(res => {
        console.log(res);
        this.codeList = res.data.data.indexCodeList;
        this.pictureNews = res.data.data.pictureNews;
        this.bottomInfoList = [];
        res.data.data.indexPic.forEach(v => {
          if (v.picType == '04') {
            this.bottomInfoList.push(v);
          }
        });
        this.yunYingList = res.data.data.yunYinPic;
        this.yunYingList.forEach(v => {
          v.picDesc = v.picDesc.replace(/<\/?p>/gi, '');
          if (v.picType == '08') {
            this.yyTtitle = v.picDesc;
          }
          if (v.picTitle == '已合作单位') {
            this.hzdw = v.picDesc;
          }
          if (v.picTitle == '客户好评率') {
            this.hpl = v.picDesc;
          }
          if (v.picTitle == '在线学习人数') {
            this.xxrs = v.picDesc;
          }
          if (v.picTitle == '专业方向') {
            this.zyfx = v.picDesc;
          }
          if (v.picTitle == '平台课程') {
            this.ptkc = v.picDesc;
          }
          if (v.picTitle == '课程总学时') {
            this.kcxs = v.picDesc;
          }
          if (v.picTitle == '累计播放次数') {
            this.ljxx = v.picDesc;
          }
        });
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.course-service {
  padding: 40px 20px;
  background: linear-gradient(90deg, #e0f0ff 0%, #f0f8ff 100%);
  min-height: 100vh;
}

.title {
  text-align: center;
  font-size: 32px;
  color: #333;
  margin-bottom: 16px;
}

.desc {
  text-align: center;
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
}

.scroll-container {
  margin-top: 40px;
  overflow: hidden;
}

.scroll-row {
  display: flex;
  margin-bottom: 16px;
  white-space: nowrap;
  /* 核心：动画属性移到行容器上，方便控制暂停/恢复 */
  animation-duration: 80s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

/* 向右滚动（第1、3行） */
.scroll-row.right {
  animation-name: marquee-right;
}

/* 向左滚动（第2、4行） */
.scroll-row.left {
  animation-name: marquee-left;
}

.scroll-content {
  display: flex;
  flex-shrink: 0;
}

/* 复制一份内容实现无缝循环 */
.scroll-content.clone {
  // margin-left: 20px;
}

.card {
  margin-right: 20px;
  min-width: 160px;
  text-align: center;
  cursor: pointer; /* 鼠标悬浮显示手型，提升交互感知 */
  transition: background 0.3s;
  margin-bottom: 22px;
  width: 150px;
  height: 72px;
  background: rgba(255, 255, 255, 0.64);
  box-shadow: 0px 2px 15px 0px rgba(138, 138, 138, 0.08), inset 0px 20px 50px 0px #f0f3f9;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #ffffff;
  padding: 0 10px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
}

/* 卡片悬浮高亮 */
.card:hover {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.card-text {
  font-size: 16px;
  color: #333;
  white-space: pre-line;
}

/* 向右滚动动画 */
@keyframes marquee-right {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

/* 向左滚动动画 */
@keyframes marquee-left {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
.imgText {
  font-size: 15px;
  font-family: kaiti;
  text-align: center;
  padding: 0px 10px;
  font-weight: bold;
  color: rgb(53, 95, 217);
  position: relative;
  z-index: 2;
}

.flowTk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  overflow: hidden;
  display: flex;
  justify-content: center;

  .tkBox {
    position: relative;

    .close {
      position: absolute;
      top: 80px;
      right: 0px;
      z-index: 99;
      width: 50px;
      cursor: pointer;
    }

    .tkImg {
      width: 600px;
      margin-top: 80px;
      cursor: pointer;
    }
  }
}

.tk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;

  .wtkBox {
    width: 440px;
    height: 193px;
    position: relative;
    padding: 26px 29px;

    .tkBac {
      position: absolute;
      top: 0;
      left: 0;
      width: 447px;
      height: 209px;
      z-index: -1;
    }

    .closeBox {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 14px;
      right: 15px;
      cursor: pointer;
    }

    .wxTtile {
      font-size: 18px;
      color: #333333;
    }

    .wx2 {
      margin-top: 14px;
      font-size: 16px;
      color: #333;
    }

    .wxBtn {
      margin-top: 23px;
      width: 120px;
      height: 40px;
      background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
      box-shadow: 0px 3px 4px 0px rgba(21, 85, 202, 0.31);
      border-radius: 20px 20px 20px 20px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      cursor: pointer;
    }
  }
}

.btnShop {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;
  color: #4076f6;
  font-size: 16px;
  font-weight: 500;
  width: 200px;
  height: 48px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid;
  border-image: linear-gradient(97deg, rgba(149, 181, 255, 1), rgba(64, 147, 246, 1)) 1 1;

  img {
    width: 26px !important;
    height: 12px;
  }
}

.flexCenter {
  display: flex;
  justify-content: center;
}

.w {
  width: 1400px;
}

.bgc {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  .fsk {
    margin-top: 186px;
    width: 1048px;
    display: flex;
    justify-content: center;

    .txt1 {
      margin-top: 15px;
      margin-bottom: 24px;
      color: #fff;
      font-size: 18px;
      text-align: center;
    }

    .swInput {
      display: flex;

      .searCh {
        width: 696px;
        height: 52px;
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
        border: 0 !important;
        border-radius: 6px 0px 0px 6px;
        font-size: 16px;
        padding-left: 24px;
      }

      input::placeholder {
        color: #fff !important;
        /* 设置颜色 */
      }

      .searBtn {
        width: 109px;
        height: 52px;
        background: linear-gradient(48deg, #6996ff 0%, #4076f6 100%);
        border-radius: 0px 6px 6px 0px;
        color: #ffffff;
        font-size: 18px;
        text-align: center;
        line-height: 52px;
        cursor: pointer;
      }
    }

    .listBox {
      position: relative;
      margin-top: 20px;
      width: 100%;
      height: 370px;
      background: rgba(2, 26, 61, 0.37);
      display: flex;
      border-radius: 6px 6px 6px 6px;
      padding: 23px 50px 25px 50px;
      backdrop-filter: blur(5px);

      .su {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1px;
        height: 90px;
        background: rgba(255, 255, 255, 0.2);
      }

      img {
        width: 20px;
        height: 20px;
      }

      .zjBox {
        width: 50%;
        font-size: 18px;

        .cpBox {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          height: 200px;

          .lBxp {
            cursor: pointer;
            // width: 80px;
            padding: 0 10px;
            height: 30px;
            background: rgba(255, 255, 255, 0);
            border-radius: 15px 15px 15px 15px;
            line-height: 30px;
            color: #ffffff;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-right: 4px;
            margin-bottom: 4px;
            text-align: center;
          }

          .lBxp:hover {
            background: rgba(255, 255, 255, 0.5) !important;
            border-radius: 15px 15px 15px 15px !important;
          }

          .lBxp:nth-child(4n) {
            margin-right: 0 !important;
          }
        }

        .btnMore {
          margin-top: 20px;
          width: 90px;
          height: 30px;
          border-radius: 15px 15px 15px 15px;
          border: 1px solid rgba(255, 255, 255, 0.6);
          cursor: pointer;
          text-align: center;
          line-height: 30px;
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
        }

        .btnMore:hover {
          color: #fff !important;
          border: 0 !important;
          background: #24bd59;
          border-radius: 15px 15px 15px 15px;
        }

        .btnMoreHover:hover {
          color: #fff !important;
          border: 0 !important;
          background: #ff8833;
          border-radius: 15px 15px 15px 15px;
        }
      }
    }

    .jiti {
      padding: 0 24px;
      width: 1048px;
      justify-content: space-between;
      height: 60px;
      background: rgba(2, 26, 61, 0.5);
      border-radius: 8px 8px 8px 8px;
      border: 0.5px solid rgba(255, 255, 255, 0.1);
      margin-top: 20px;
      display: flex;
      align-items: center;

      .jintuText {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        width: 79px;
        line-height: 22px;
        height: 22px;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
        font-size: 16px;
        color: #ffffff;
      }

      .jinru_1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        margin-left: 15px;
      }

      .jinru_btn {
        width: 90px;
        height: 32px;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .listBox2 {
      margin-top: 30px;
      width: 1048;
      display: flex;
      align-items: center;
      justify-content: space-between;
      backdrop-filter: blur(10px);

      .fwBox {
        width: 250px;
        height: 160px;
        background: rgba(2, 26, 61, 0.37);
        border-radius: 8px;
        border: 0.5px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;

        .txt2 {
          display: flex;
          align-items: center;
          font-size: 16px;
          height: 22px;

          img {
            margin-top: 6px;
            width: 18px;
            height: 18px;
          }
        }

        .txt3 {
          padding-left: 30px;
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
          margin-top: 8px;
        }

        .txt4 {
          text-align: center;
          line-height: 48px;
          color: #fff;
          font-size: 14px;
          opacity: 0.8;
        }

        .bor {
          margin: 0 auto;
          width: 160px;
          height: 0.5px;
          background: rgba(255, 255, 255, 0.2);
        }
      }

      .fwBox:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
  }
}

.jyBox {
  position: relative;
  width: 100%;
  height: 655px;
  background: #ffffff;
  padding-top: 100px;
  padding-left: 260px;

  .zcBox {
    display: flex;

    .vitts {
      position: relative;
      width: 322px;
      height: 417px;
      background: #217cbe;

      .citsImg {
        position: absolute;
        top: 38px;
        left: 33px;
        z-index: 1;
      }
    }

    .zcText {
      font-size: 20px;
      width: 976px;
      margin-left: 102px;
      line-height: 31px;

      .tbox {
        margin-top: 34px;
      }
    }
  }
}

.kc {
  position: relative;
  width: 100%;
  height: 747px;
  display: flex;
  justify-content: center;

  .bgcs {
    position: absolute;
    top: 0;
    width: 100%;
    height: 747px;
    z-index: -1;
  }

  .kcList {
    height: 236px;
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    width: 1400px;
    border-radius: 10px 10px 10px 10px;
    justify-content: space-between;

    .kcB {
      width: 49.5%;
      height: 236px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      cursor: pointer;
      padding: 30px;
      display: flex;
      box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16), inset 0px 20px 50px 0px #f0f3f9;

      .fm {
        width: 220px;
        height: 170px;
      }

      .fmImg {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 100%;
        height: 100%;
      }

      .imgText {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }

      .bt {
        width: 380px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        color: #000;
        margin: 10px 0 12px 0;
        font-weight: bold;
      }

      .fl {
        display: flex;
        margin-bottom: 12px;

        .flx {
          padding: 0 12px;
          height: 23px;
          text-align: center;
          line-height: 23px;
          background: rgba(64, 118, 246, 0.1);
          border-radius: 2px 2px 2px 2px;
          color: #4076f6;
          font-size: 14px;
          margin-right: 12px;
        }
      }

      .studyTime {
        margin-bottom: 8px;
        font-size: 14px;
        color: #656e7e;
      }

      .btm {
        margin-top: 8px;
        display: flex;
        color: #ff6632;
        align-items: center;

        .skBtn {
          width: 90px;
          height: 36px;
          background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          line-height: 36px;
          color: #fff;
          font-size: 12px;
          color: #fff;
          margin-left: 25px;
          box-shadow: 0px 5px 15px 0px rgba(64, 147, 246, 0.3);
        }

        .ljgm {
          margin-left: 12px;
          background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%) !important;
          box-shadow: 0px 5px 15px 0px rgba(196, 8, 12, 0.3) !important;
        }
      }
    }

    // .kcB:hover {
    //   .fm {
    //     /* 设置放大比例 */
    //     transform: scale(1.1) !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }
    //   .bt {
    //     color: #4076f6 !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }
    //   .flx {
    //     background: rgba(64, 118, 246, 0.1) !important;
    //     border-radius: 2px 2px 2px 2px !important;
    //     color: #4076f6 !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }

    //   .skBtn {
    //     transition: opacity 1s ease; /* 添加过渡效果 */
    //     opacity: 1; /* 初始不透明度 */
    //   }
    // }
  }

  .newKcList {
    margin-top: 27px;
    width: 1400px;
    height: 330px;
    background: #ffffff;
    box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16), inset 0px 20px 50px 0px #f0f3f9;
    border-radius: 10px 10px 10px 10px;
    padding: 30px 30px 0 30px;
    display: flex;
    justify-content: space-between;

    .newBox {
      width: 200px;
      cursor: pointer;

      .fmDiv {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 160px;
        overflow: hidden;
      }

      .fmImg {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
      }

      .imgText {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }

      img {
        width: 200px;
        height: 160px;
      }

      .ntext1 {
        width: 200px;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 10px 0 7px 0;
      }

      .nax {
        display: flex;
        justify-content: space-between;

        .na1 {
          width: 56px;
          height: 23px;
          background: #f6f6f6;
          border-radius: 2px 2px 2px 2px;
          text-align: center;
          line-height: 23px;
          color: #666666;
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .pric {
        margin-top: 10px;
        color: #ff6632;
        display: flex;
        font-size: 20px;
      }
    }
  }
}

.zyjs {
  width: 100%;
  background: #f7f8fb;
  padding: 80px 0;
  display: flex;
  justify-content: center;

  .xwzx {
    width: 1400px;

    .xwTitle {
      text-align: center;
      color: #333333;
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 50px;
    }

    .zxList {
      width: 1400px;
      display: flex;
      flex-wrap: wrap;

      .zxBox:nth-child(2n) {
        margin-right: 0 !important;
      }

      .zxBox {
        display: flex;
        cursor: pointer;
        margin-right: 60px;
        margin-bottom: 30px;

        .z1 {
          width: 280px;
          height: 160px;
          border-radius: 8px 8px 8px 8px;
          background: #ccc;
        }

        .z2 {
          margin-left: 20px;

          .z3 {
            margin-top: 8px;
            color: #000;
            font-size: 20px;
          }

          .z4 {
            margin-top: 10px;
            width: 370px;
            height: 66px;
            color: #666666;
            font-size: 16px;
            overflow: hidden;
          }

          .z5 {
            color: #666666;
            font-size: 16px;
            text-align: right;
            margin-top: 20px;
          }
        }
      }
    }

    .moreZx {
      cursor: pointer;
      margin: 20px auto auto auto;
      width: 200px;
      height: 48px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #217cbe;
      display: flex;
      align-items: center;
      padding-left: 38px;
      color: #217cbe;
      font-size: 16px;
    }
  }
}

.gm {
  position: relative;
  width: 100%;
  height: 918px;
  padding: 80px 0;
  display: flex;
  justify-content: center;

  .gm1 {
    width: 1400px;

    .gmTitle {
      text-align: center;
      color: #333333;
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .g2 {
      font-size: 14px;
      color: #666;
      text-align: center;
    }

    .giconList {
      width: 1400px;
      margin-top: 50px;
      display: flex;
      justify-content: space-around;

      .gi1 {
        cursor: pointer;
        width: 220px;
        height: 150px;
        background: linear-gradient(0deg, #f7f9fa 0%, #ffffff 100%);
        border-radius: 8px 8px 8px 8px;
        border: 1px solid;
        border-image: linear-gradient(124deg, rgba(228, 230, 231, 1), rgba(245, 245, 245, 1), rgba(228, 230, 231, 1)) 1 1;
        display: flex;
        justify-content: center;
        padding: 15px 0;

        .gi2 {
          margin-top: 8px;
          font-size: 18px;
          color: #333;
          text-align: center;
        }

        .gi3 {
          margin-top: 4px;
          color: #999999;
          font-size: 14px;
        }
      }
    }

    .gmxc {
      margin-top: 30px;
      display: flex;
      justify-content: space-around;
      .gmxc1 {
        padding: 30px;
        position: relative;
        width: 330px;
        height: 460px;
        background: linear-gradient(0deg, #e7f5fb 0%, #f7fcfe 100%);
        border-radius: 8px 8px 8px 8px;
        .gc1 {
          position: absolute;
          bottom: 0;
          right: 0;
        }
        .g1Img {
          position: absolute;
          right: 30px;
          top: 30px;
        }
        .t1 {
          font-weight: bold;
          font-size: 24px;
          color: #333333;
        }
        .t2 {
          margin-top: 8px;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
        }
        .t3 {
          margin-bottom: 9px;
          font-weight: 400;
          font-size: 18px;
          color: #666666;
        }
      }
      .gmxc2 {
        .t4 {
          width: 330px;
          height: 220px;
          background: #f6f6fb;
          border-radius: 8px 8px 8px 8px;
          padding: 30px;
          position: relative;
          margin-bottom: 20px;
          .t1 {
            font-weight: bold;
            font-size: 24px;
            color: #333333;
          }
          .t2 {
            margin-top: 8px;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
          }
          .t3 {
            margin-top: 75px;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
          }
          .g1Img {
            position: absolute;
            right: 30px;
            top: 30px;
          }
        }
      }
    }
  }
}

.kcfw {
  width: 100%;
  height: 620px;
  overflow: hidden;
  position: relative;
  padding-top: 70px;
  z-index: 2;
  /* 兼容写法 */
  mask: linear-gradient(90deg, transparent 0%, #000 15%, #000 85%, transparent 100%);
  -webkit-mask: linear-gradient(90deg, transparent 0%, #000 15%, #000 85%, transparent 100%);

  .zyList {
    width: 1200px;
    display: flex;
    margin: 51px auto;
    justify-content: space-around;
    .z1 {
      width: 320px;
      height: 400px;
      background: #ffffff;
      padding: 24px 20px;
      .z2 {
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }
      .z3 {
        margin-top: 12px;
        font-weight: 400;
        font-size: 16px;

        color: #666666;
      }
      .z4 {
        margin-top: 20px;
        width: 280px;
        height: 180px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .z1:nth-child(4) {
      margin-right: 0 !important;
    }
  }
  .kcbgc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    height: 100%;
  }
  .gmTitle {
    text-align: center;
    color: #333333;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .g2 {
    font-size: 14px;
    color: #666;
    text-align: center;
  }
}
/* 滚动轨道：承载两个scroll-content，必须是flex一行排列 */
.scroll-track {
  margin-top: 46px;
  display: flex; /* 关键：让两个scroll-content横向排列 */
  animation: scroll-left 10s linear infinite; /* 20秒一轮，匀速，无限循环 */
}

/* 新增：鼠标悬停暂停滚动（提升体验） */
.kcfw .gdBox:hover {
  animation-play-state: paused;
}
.csw {
  width: 100%;
  padding: 80px 0;
  .kcbgc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    height: 100%;
  }
  .gmTitle {
    text-align: center;
    color: #333333;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .g2 {
    font-size: 14px;
    color: #666;
    text-align: center;
  }

  .hzImg {
    width: 1400px;
    height: 484px;
    margin: 50px auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.kcfw1 {
  width: 100%;
  height: 620px;
  overflow: hidden;
  position: relative;
  padding-top: 70px;
  z-index: 2;
  .kcbgc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    height: 100%;
  }
  .gmTitle {
    text-align: center;
    color: #333333;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .g2 {
    font-size: 14px;
    color: #666;
    text-align: center;
  }
  .zyList {
    width: 1200px;
    display: flex;
    margin: 51px auto;
    .z1 {
      width: 320px;
      height: 400px;
      background: #ffffff;
      padding: 24px 20px;
      margin-right: 40px;
      .z2 {
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }
      .z3 {
        margin-top: 12px;
        font-weight: 400;
        font-size: 16px;
        height: 110px;
        overflow: hidden;
        color: #666666;
      }
      .z4 {
        margin-top: 20px;
        width: 280px;
        height: 180px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .z1:nth-child(4) {
      margin-right: 0 !important;
    }
  }
}
</style>
